import axios from "axios";

export const AuthToken = () => {
  return axios({
    url: "https://interactive-virtualhuman.xiaoice.com/openapi/signature/gen",
    method: "GET",
    headers: {
      "subscription-key": "90b81dd9ed854054871b33a0922d15d7",
    },
  });
};

export const sendText = (query) => {
  return fetch("https://chat.uhan.net.cn:9993/api/admin/uhanModel/chat1", {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Accept: "text/event-stream", // 指明接收的内容类型是 event-stream
    },
    body: JSON.stringify({
      responseMode: "streaming",
      inputs: {},
      query,
    }),
  });
};
